import React, { useState, useEffect } from 'react';
import { doc, setDoc, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../../firebaseConfig';
import { useToast } from '../../components/CustomToast'; // Added import

function NotificationsPanel() {
  const [comments, setComments] = useState(true);
  const [mentions, setMentions] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const { addToast } = useToast(); // Initialize toast

  // Fetch user's notification settings
  useEffect(() => {
    if (!auth.currentUser) return;

    const unsubscribe = onSnapshot(
      doc(db, 'userSettings', auth.currentUser.uid),
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setComments(data.notifications?.comments ?? true);
          setMentions(data.notifications?.mentions ?? false);
        }
      }
    );

    return () => unsubscribe();
  }, [auth.currentUser, db]);

  const saveChanges = async () => {
    if (!auth.currentUser) return;

    setIsSaving(true);
    try {
      await setDoc(
        doc(db, 'userSettings', auth.currentUser.uid),
        {
          notifications: {
            comments,
            mentions,
          },
        },
        { merge: true }
      );
      addToast('Indstillinger gemt succesfuldt!', 'success'); 
    } catch (error) {
      console.error('Kunne ikke gemme notifikations indstillinger, tjek dit internet:', error);
      addToast('Kunne ikke gemme notifikations indstillinger, tjek dit internet', 'error');
    }
    setIsSaving(false);
  };

  return (
    <div className="grow">

      {/* Panel body */}
      <div className="p-6 space-y-6">
        <h2 className="text-2xl text-gray-800 dark:text-gray-100 font-bold mb-5">Mine notifikationer</h2>

        {/* General */}
        <section>
          <h3 className="text-xl leading-snug text-gray-800 dark:text-gray-100 font-bold mb-1">Generalt</h3>
          <ul>
            <li className="flex justify-between items-center py-3 border-b border-gray-200 dark:border-gray-700/60">
              {/* Left */}
              <div>
                <div className="text-gray-800 dark:text-gray-100 font-semibold">Kommentarer og svar</div>
                <div className="text-sm">Dette er notifikationer for aktier du følger. Du vil modtage notifikationer når der er omtale om aktien/aktierne du følger</div>
              </div>
              {/* Right */}
              <div className="flex items-center ml-4">
                <div className="text-sm text-gray-400 dark:text-gray-500 italic mr-2">
                  {comments ? 'Slået til' : 'Slået fra'}
                </div>
                <div className="form-switch">
                  <input
                    type="checkbox"
                    id="comments"
                    className="sr-only"
                    checked={comments}
                    onChange={() => setComments(!comments)}
                  />
                  <label className="bg-gray-400 dark:bg-gray-700" htmlFor="comments">
                    <span className="bg-white shadow-sm" aria-hidden="true"></span>
                  </label>
                </div>
              </div>
            </li>
          
            <li className="flex justify-between items-center py-3 border-b border-gray-200 dark:border-gray-700/60">
              {/* Left */}
              <div>
                <div className="text-gray-800 dark:text-gray-100 font-semibold">Omtale</div>
                <div className="text-sm">Har du lavet et indlæg, så kan der komme omtale fra andre brugere, så der kan skabes en debat.</div>
              </div>
              {/* Right */}
              <div className="flex items-center ml-4">
                <div className="text-sm text-gray-400 dark:text-gray-500 italic mr-2">
                  {mentions ? 'Slået til' : 'Slået fra'}
                </div>
                <div className="form-switch">
                  <input
                    type="checkbox"
                    id="mentions"
                    className="sr-only"
                    checked={mentions}
                    onChange={() => setMentions(!mentions)}
                  />
                  <label className="bg-gray-400 dark:bg-gray-700" htmlFor="mentions">
                    <span className="bg-white shadow-sm" aria-hidden="true"></span>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </section>

        {/* Shares */}
       
      </div>

      {/* Panel footer */}
      <footer>
        <div className="flex flex-col px-6 py-5 border-t border-gray-200 dark:border-gray-700/60">
          <div className="flex self-end">
            <button 
              className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white ml-3"
              onClick={saveChanges}
              disabled={isSaving}
            >
              {isSaving ? 'Gemmer...' : 'Gem ændringer'}
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default NotificationsPanel;